// Mini-przewodniki pojedynczych stron — „wchodzisz i wiesz, co gdzie jest".
// Każda strona z menu ma swój (pilnuje tego test), więc przewodnik działa wszędzie tak samo.
//
// JEDEN WZÓR dla wszystkich (2026-10-02, wcześniej część stron miała podświetlenie, część
// dużą kartę na środku, a część nie miała przewodnika wcale):
// - dokładnie dwa kroki, każdy z wstępem i trzema punktami,
// - KAŻDY krok podświetla konkretny element strony (`target`, kotwica `data-tour`), a karta
//   staje obok niego. Karta na środku zostaje wyłącznie jako zapas, gdy elementu nie ma na
//   ekranie (np. sekcja tylko dla administratora albo inny układ na telefonie).
//
// Spacer po aplikacji (utils/demoTour.js) przechodzi przez część tych samych stron, ale
// pokazuje tam tylko pozycję w menu. Żeby po jego zamknięciu nie wyskakiwał od razu drugi
// przewodnik strony, na której się skończył, `components/PageTour.js` odkłada go do
// następnego wejścia na tę stronę.
//
// Kroki nie mają `route` — mini-przewodnik nigdzie nie nawiguje, opisuje stronę, na której
// użytkownik już jest.
//
// Treść kroków to KLUCZE i18n `pageTours.<id przewodnika>.<klucz kroku>.title|lead|p1-p3`
// (P8.1e). Rozwija je `components/PageTour.js` PRZED przekazaniem do `TourOverlay`.
//
// UWAGA: `id` przewodnika jest częścią klucza „widziane" w localStorage
// (`pageTourSeen:v1:<user>:<id>`). Zmiana id = przewodnik pokaże się ponownie wszystkim.

const STORAGE_PREFIX = 'pageTourSeen:v1';

const krok = (tourId, stepKey, anchor) => ({
  id: `${tourId}-${stepKey}`,
  titleKey: `pageTours.${tourId}.${stepKey}.title`,
  leadKey: `pageTours.${tourId}.${stepKey}.lead`,
  target: `[data-tour="${anchor}"]`,
  pointKeys: [1, 2, 3].map((n) => `pageTours.${tourId}.${stepKey}.p${n}`),
});

const przewodnik = (id, route, kroki) => ({
  id,
  route,
  titleKey: `pageTours.${id}.title`,
  steps: kroki.map(([stepKey, anchor]) => krok(id, stepKey, anchor)),
});

// Kolejność jak w menu (components/sidebar.js), potem strony otwierane z Profilu.
export const PAGE_TOURS = [
  przewodnik('home', '/home', [['favorites', 'home-favorites'], ['upcoming', 'home-upcoming']]),
  przewodnik('reservation', '/reservation', [['client', 'reservation-client'], ['equipment', 'reservation-equipment']]),
  przewodnik('calendar', '/calendar', [['day', 'calendar-day-panel'], ['tabs', 'calendar-tabs']]),
  przewodnik('offers', '/generate-offer', [['form', 'offers-client'], ['history', 'offers-tabs']]),
  przewodnik('clients', '/clients', [['search', 'clients-search'], ['card', 'clients-card']]),
  przewodnik('inventory', '/inventory', [['actions', 'inventory-actions'], ['filters', 'inventory-filters']]),
  przewodnik('payments', '/payments', [['list', 'payments-filters'], ['deposits', 'payments-summary']]),
  przewodnik('statistics', '/statistics', [['charts', 'stats-controls'], ['kpi', 'stats-kpi']]),
  przewodnik('contract-template', '/contract-template', [['start', 'contract-start'], ['preview', 'contract-preview']]),
  przewodnik('offer-template', '/offer-template', [['fields', 'offer-fields'], ['preview', 'offer-preview']]),
  przewodnik('payment-settings', '/payment-settings', [['intro', 'payment-settings-intro'], ['account', 'payment-settings-account']]),
  przewodnik('invoices', '/invoices', [['new', 'invoices-new'], ['filters', 'invoices-filters']]),
  przewodnik('notifications', '/notifications', [['email', 'notifications-email'], ['sms', 'notifications-sms']]),
  przewodnik('widget', '/widget-media', [['preview', 'widget-preview'], ['embed', 'widget-embed']]),
  przewodnik('profile', '/profile', [['account', 'profile-account'], ['company', 'profile-company']]),
  przewodnik('price-rules', '/price-rules', [['presets', 'price-presets'], ['form', 'price-new']]),
  przewodnik('equipment-bundles', '/equipment-bundles', [['presets', 'bundles-new'], ['effect', 'bundles-list']]),
];

export function getPageTour(pathname) {
  if (!pathname) return null;
  return PAGE_TOURS.find((tour) => tour.route === pathname) || null;
}

export function pageTourStorageKey(userId, tourId) {
  return `${STORAGE_PREFIX}:${userId ?? 'anon'}:${tourId}`;
}

// Odczyt/zapis odporne na wyłączony localStorage — w najgorszym razie
// mini-przewodnik pokaże się jeszcze raz, nic się nie psuje.
export function isPageTourSeen(storage, userId, tourId) {
  try {
    return storage?.getItem(pageTourStorageKey(userId, tourId)) === '1';
  } catch (_) {
    return false;
  }
}

export function markPageTourSeen(storage, userId, tourId) {
  try {
    storage?.setItem(pageTourStorageKey(userId, tourId), '1');
  } catch (_) {
    // brak miejsca / tryb prywatny — przewodnik po prostu pokaże się ponownie
  }
}
